import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-adduserrole',
  templateUrl: './adduserrole.component.html',
  styleUrls: ['./adduserrole.component.css']
})
export class AdduserroleComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: string = "UserRole";

  //Display
  formmode: string = "Add";

  editformtype: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  urolerightsColl: any = [];

  //Edit Get Values
  userroleColl: any = [];
  userroleBO: any = {};
  userroleid: number = 0
  moduleColl: any = [];
  moduleBO: any = {};

  userroleform = new FormGroup({
    userroleid: new FormControl(0),
    userrolename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.userroleid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.userroleform.reset();
      this.fnInitializeFormGroup();

      if (this.userroleid > 0) {
        this.fngetUserRole();
      }

      this.fngetUserRoleRights();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.userroleid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit() {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup() {
    this.userroleform.setValue({
      userroleid: 0,
      userrolename: '',
      inactive: false
    })
  }


  //Get 
  fngetUserRole() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'userroleid': this.userroleid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getUserRole(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.userroleColl = res.json().result;
            var editdata = this.userroleColl[0];
            this.fnEditMode(editdata);
            this.userroleBO = editdata;
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fngetUserRoleRights() {

    var data = {
      'userroleid': this.userroleid,
    }
    this.appService.getUserRoleRights(data)
      .subscribe(
        (res) => {
          var result = res.json().result;
          
          this.urolerightsColl = result[0];
          this.moduleColl = result[1];
          this.fnSetTable();

          if (this.moduleColl.length > 0) {
            this.fnTabClickModule(this.moduleColl[0])
          }
         

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.userroleform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'userroleid': this.userroleid,
          'userrolename': this.userroleform.get('userrolename').value,
          'inactive': this.userroleform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'urolerightsColl': this.urolerightsColl
        }


        this.appService.fnCheckUserRole(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;
              console.log(res.json())
              if (_checkresult === "done") {
                if (this.userroleform.get('userroleid').value > 0) {
                  //Update 
                  this.fnSetUserRole(data);
                }
                else {
                  //Insert 
                  this.fnInsertUserRole(data);
                }
              }
              else {
                if (_checkresult === "name") {
                  this.saveloading = false;
                  this.userroleform.controls['userrolename'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertUserRole(data) {

    this.appService.fnInsertUserRole(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new userrole has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.userrolename);

            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetUserRole(data) {

    this.appService.fnSetUserRole(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The userrole has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.userroleid, data.userrolename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/UserRole']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.userroleform.setValue({
      userroleid: deptBO.userroleid,
      userrolename: deptBO.userrolename,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnSetTable() {

  }

  fnCheckAllRights(event, deptBO) {


    if (event) {
      if (deptBO.ucreate) {
        deptBO.uappcreate = true;
      }
      if (deptBO.ualter) {
        deptBO.uappalter = true;
      }
      if (deptBO.udelete) {
        deptBO.uappdelete = true;
      }
      if (deptBO.uview) {
        deptBO.uappview = true;
      }
      if (deptBO.uprint) {
        deptBO.uappprint = true;
      }
      if (deptBO.uexport) {
        deptBO.uappexport = true;
      }
      if (deptBO.upayment) {
        deptBO.uapppayment = true;
      }
      if (deptBO.uapproval) {
        deptBO.uappapproval = true;
      }
      if (deptBO.ureject) {
        deptBO.uappreject = true;
      }


    }
    else {
     

      deptBO.uappcreate = false;
      deptBO.uappalter = false;
      deptBO.uappdelete = false;
      deptBO.uappview = false;
      deptBO.uappprint = false;
      deptBO.uappexport = false;
      deptBO.uapppayment = false;
      deptBO.uappapproval = false;
      deptBO.uappreject = false;
    }



  }


  fnSaveAsBtnClick() {
    try {
      this.userroleid = 0;
      this.fnInitializeFormGroup();
      this.router.navigate([]);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnTabClickModule(item) {
    this.editformtype = item.modulename;

    for (let abo of this.moduleColl) {
      if (abo.modulename === item.modulename) {
        abo.activeCls = "activetab"
        
        this.moduleBO=abo
      }
      else {
        abo.activeCls=""
      }
    }



  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }








}
